export default "__VITE_ASSET__Dd818usa__"